import { useEffect } from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'

import type { ILexicalSyncState } from './lexical-sync-state.types'
import { editorStateToHTML, HTMLToEditorState } from '../text-editor/text-editor.utils'

export const useLexicalSyncStateModel = ({ textValue }: ILexicalSyncState) => {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    const currentState = editorStateToHTML(editor)
    if (textValue !== currentState) {
      HTMLToEditorState(textValue)(editor)
    }
  }, [editor, textValue])
}
